import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import BellIcon from 'icons/Bell.icon';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';

import './NewBadge.styles.scss';

type NewBadgeProps = {
  className?: string;
  variant?: ColorVariants;
  showIcon?: boolean;
};

const NewBadge: React.FC<NewBadgeProps> = (props) => {
  const {
    className,
    variant = COLOR_VARIANT.DARK_GREEN_FULL,
    showIcon = true,
  } = props;

  const classes = classNames('new-badge', variant, className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {t('new')}
      {showIcon && <BellIcon />}
    </div>
  );
};

export default NewBadge;
